<template lang="pug">
  #card(style="min-height: 100vh; overflow-y: scroll;")
    router-view
</template>

<script>
  import { M_CARD_INDEX } from '@/router/member/card';

  export default {
    // 不管這邊打大小寫 顯示都會是以大寫形式為主
    name: 'MemberCardComponent',
    components: {
    },
    data() {
      return {
        route: M_CARD_INDEX,
        showBeforeButton: false,
      };
    },
    mounted() {
      const vm = this;
      if (vm.$route.name === 'm-card-shopping-record') vm.showBeforeButton = true;
      if (vm.$route.name === 'm-card-shopping-record') console.log(123);
    },
    watch: {
      '$route.name': {
        handler() {
          const vm = this;
          if (vm.$route.name === 'm-card-shopping-record') {
            vm.showBeforeButton = true;
          } else {
            vm.showBeforeButton = false;
          }
        },
        deep: true,
      },
    },
  };
</script>
